import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { resolveImageUrl } from '../../lib/imageUrl';

/**
 * Soft-fade crossfade between N images. If a single image, just shows it.
 * Props: images (array of urls), interval ms, className, alt
 */
const ImageCrossfade = ({ images = [], interval = 5000, className = '', alt = '' }) => {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    if (!images || images.length <= 1) return;
    const t = setInterval(() => setCurrent((p) => (p + 1) % images.length), interval);
    return () => clearInterval(t);
  }, [images, interval]);

  if (!images || images.length === 0) return <div className={className} />;

  return (
    <div className={`relative overflow-hidden ${className}`}>
      <AnimatePresence>
        {images.map((src, idx) => idx === current && (
          <motion.img
            key={`${src}-${idx}`}
            src={resolveImageUrl(src)}
            alt={alt}
            className="absolute inset-0 w-full h-full object-cover"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 1.4, ease: 'easeInOut' }}
          />
        ))}
      </AnimatePresence>
    </div>
  );
};

export default ImageCrossfade;
